import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import './App.css';

import Home from './pages/home';

const LazyAnalytics = React.lazy(() => import('@vercel/analytics/react').then(m => ({ default: m.Analytics })));
const LazySpeedInsights = React.lazy(() => import('@vercel/speed-insights/react').then(m => ({ default: m.SpeedInsights })));
// Lazy load pages
const Thanksgiving = React.lazy(() => import('./pages/thanksgiving/Thanksgiving'));
const Page1 = React.lazy(() => import('./pages/page1'));
const Whatsinseason = React.lazy(() => import('./pages/whatsinseason'));
const SunsetPredictor = React.lazy(() => import('./pages/sunset/sunsetpredictor'));
const ZhuankePage = React.lazy(() => import('./pages/zhuanke'));
const MuddyHandsPage = React.lazy(() => import('./pages/muddyhands'));
const MuddyHandsPrivacyPage = React.lazy(() => import('./pages/muddyhandsPrivacy'));
const Matcha = React.lazy(() => import('./pages/matcha/Matcha'));
const EmojiTranslator = React.lazy(() => import('./pages/emojitranslator/EmojiTranslator'));

function App() {
  return (
    <div className="App" id="App">
      <Suspense fallback={null}>
        <LazyAnalytics />
        <LazySpeedInsights />
      </Suspense>
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thanksgiving" element={<Suspense fallback={null}><Thanksgiving /></Suspense>} />
          <Route 
            path="/instagram" 
            element={
              <Suspense fallback={null}>
                <Page1 />
              </Suspense>
            } 
          />
          <Route 
            path="/whatsinseason" 
            element={
              <Suspense fallback={null}>
                <Whatsinseason />
              </Suspense>
            } 
          />
          <Route 
            path="/sunset/:city?/:date?" 
            element={
              <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: 'linear-gradient(to bottom, #87CEEB, #E0F0FF)' }} />}>
                <SunsetPredictor />
              </Suspense>
            } 
          />
          <Route 
            path="/sunrise/:city?/:date?" 
            element={
              <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: 'linear-gradient(to bottom, #87CEEB, #E0F0FF)' }} />}>
                <SunsetPredictor />
              </Suspense>
            } 
          />
          <Route 
            path="/zhuanke" 
            element={
              <Suspense fallback={null}>
                <ZhuankePage />
              </Suspense>
            } 
          />
          <Route
            path="/muddyhands"
            element={
              <Suspense fallback={null}>
                <MuddyHandsPage />
              </Suspense>
            }
          />
          <Route
            path="/muddyhands/privacy"
            element={
              <Suspense fallback={null}>
                <MuddyHandsPrivacyPage />
              </Suspense>
            }
          />
          <Route
            path="/matcha"
            element={
              <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: '#d4dcc9' }} />}>
                <Matcha />
              </Suspense>
            }
          />
          <Route
            path="/emojitranslator"
            element={
              <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: '#f5f5f5' }} />}>
                <EmojiTranslator />
              </Suspense>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
